import { createApp } from 'vue'
import store from "./store/index.js";
import router from "./router";
import App from './App.vue'
import "@/assets/css/theme.css";
import "@/assets/css/nucleo-icons.css";
import "@/assets/css/nucleo-svg.css";
import "@/assets/css/modlacss.css";
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import "@/assets/css/material-dashboard.min.css";
import "@/assets/css/dataTables.responsive.css";
import "@/assets/css/mainimagecapture.css"; 
import "@/assets/css/jquery.treetable.theme.default.css"; 
import "@/assets/css/newregistrationcss.css"; 


import "@/assets/css/style.css";




import "@/utils/wizardSteps";


import { activateDarkMode } from "@/utils/themeMode";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/vue-tel-input.css";
import "@/assets/css/ts-table.css";
import "@/assets/css/app-layering.css";
import "@/assets/css/shule-production-ready.css";
import vIdle from "v-idle-3";


const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(VueTelInput);
appInstance.use(vIdle);


if (localStorage.getItem("theme") === "1") {
  activateDarkMode();
  store.state.isDarkMode = true;
}else{
  store.state.isDarkMode = false;  
}

// main.js

const debounce = (fn, delay) => {
  let timeoutId;
  return (...args) => {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};

// Patch ResizeObserver to prevent loop errors
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    super(debounce(callback, 20));
  }
};




// Unlock audio playback on first user interaction, globally.
// Chrome/Safari block audio.play() on pages where the user hasn't
// interacted yet. We play a silent sound on the first click/keypress/touch
// to grant playback permission for the rest of the SPA session.
(function unlockAudioOnce() {
  let unlocked = false;
  const unlock = () => {
    if (unlocked) return;
    unlocked = true;
    // 0.1s of silent WAV — enough to satisfy the autoplay gesture check
    const silentAudio = new Audio('data:audio/wav;base64,UklGRjIAAABXQVZFZm10IBIAAAABAAEAQB8AAEAfAAABAAgAAABmYWN0BAAAAAAAAABkYXRhAAAAAA==');
    silentAudio.play().catch(() => { /* ignore */ });
    window.removeEventListener('click', unlock);
    window.removeEventListener('keydown', unlock);
    window.removeEventListener('touchstart', unlock);
  };
  window.addEventListener('click', unlock, { once: false });
  window.addEventListener('keydown', unlock, { once: false });
  window.addEventListener('touchstart', unlock, { once: false });
})();




// ALTERNATIVELY: Just suppress the error message globally
const resizeObserverLoopErr = 'ResizeObserver loop completed with undelivered notifications.';

window.addEventListener('error', (event) => {
  if (event.message === resizeObserverLoopErr) {
    event.stopImmediatePropagation();
  }
});

// ... createPagination, createApp, etc.

appInstance.mount("#app");



